module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.7b225d4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/font/Roboto-Medium.woff
// module id = gR3c
// module chunks = 0